import "./MainSpace.css";

import React from "react";

const MainSpace = (props: any) => {
  return <main>{props.children}</main>;
};

export default MainSpace;
